import { MainButton } from '@justomx/atlas-design-system'
import { useTranslation } from 'react-i18next'
import { SelectCountryMolecule } from 'design-system/molecule/SelectCountry.molecule'
import { useCountry } from './Country.hook'

export const CountryPage = () => {
  const { t } = useTranslation('global')
  const { actions, country } = useCountry()

  return (
    <div className="flex flex-col flex-grow gap-4 overflow-auto py-10 px-4">
      <SelectCountryMolecule
        country={country}
        setCountry={actions.onSelectCountry}
      />

      <div className="fixed bottom-0 left-0 right-0 w-full p-4">
        <MainButton
          type="button"
          text={t('common.continue')}
          onClick={actions.onContinue}
          disabled={!country}
        />
      </div>
    </div>
  )
}
